// Based on https://github.com/carlsvelz's implementation
// https://github.com/carlsvelz/website/blob/b05d6722e8af79806b180902dbd27db384dc9dd6/src/lib/components/faqs/faq.svelte

import EventsTracking from '../../../shared/eventsTracking';

const trackedSections = new Set();

function setup(el, binding) {
  const collapseAttribute = 'data-collapse';
  const animationConfig = {
    duration: 300,
    easing: 'ease-out',
  };

  let accordionGroup = null;
  let animation = null;
  el.isClosing = false;
  let isExpanding = false;
  const summary = el.querySelector('summary');
  const content = el.querySelector('.rfp-details__contents');

  if (el.dataset.faqGroup) {
    accordionGroup = el.dataset.faqGroup;
  }
  if (typeof binding.value?.duration === 'number') {
    animationConfig.duration = binding.value.duration;
  }

  const closeOtherAccordions = () => {
    if (accordionGroup === null) return;
    const matches = document.querySelectorAll(`[data-faq-group='${accordionGroup}']`);

    matches.forEach(function (acord) {
      if (acord !== el) {
        acord.setAttribute(collapseAttribute, true);
      }
    });
  };

  const onAnimationFinish = (isOpen) => {
    el.open = isOpen;
    animation = null;
    el.isClosing = false;
    isExpanding = false;
    el.style.height = el.style.overflow = '';
    el.querySelector('summary').setAttribute('aria-expanded', isOpen);
  };

  const expand = () => {
    isExpanding = true;
    const startHeight = `${el.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

    if (animation) {
      animation.cancel();
    }

    // Start a WAAPI animation
    animation = el.animate(
      {
        height: [startHeight, endHeight],
      },
      animationConfig,
    );

    animation.onfinish = () => onAnimationFinish(true);
    animation.oncancel = () => (isExpanding = false);
  };

  const open = () => {
    el.style.height = `${el.offsetHeight}px`;
    el.open = true;
    window.requestAnimationFrame(() => expand());
  };

  const shrink = () => {
    el.isClosing = true;
    const startHeight = `${el.offsetHeight}px`;
    const endHeight = `${summary.offsetHeight}px`;

    if (animation) {
      animation.cancel();
    }

    // Start a WAAPI animation
    animation = el.animate(
      {
        height: [startHeight, endHeight],
      },
      animationConfig,
    );

    animation.onfinish = () => onAnimationFinish(false);
    animation.oncancel = () => (el.isClosing = false);
  };

  summary.addEventListener('click', (e) => {
    e.preventDefault();
    closeOtherAccordions();
    el.style.overflow = 'hidden';
    if (el.isClosing || !el.open) {
      open();
    } else if (isExpanding || el.open) {
      shrink();
    }
  });

  el.observer = new MutationObserver(function (mutationsList) {
    if (
      mutationsList.length === 1 &&
      mutationsList[0].attributeName === collapseAttribute &&
      el.getAttribute(collapseAttribute) &&
      (isExpanding || el.open)
    ) {
      el.style.overflow = 'hidden';
      shrink();
      el.removeAttribute(collapseAttribute);
    }
  });

  el.observer.observe(el, { attributes: true });

  // collect the current group's tagging id
  const taggingId = el.parentElement?.dataset?.refappTaggingId;

  if (!taggingId) {
    console.warn('No tagging id found on the component root');
    return;
  }

  // prevent multiple EventsTracking instances for the same FAQ section
  if (trackedSections.has(taggingId)) return;

  trackedSections.add(taggingId);
  new EventsTracking(taggingId);
}

function cleanup(el) {
  el.observer.disconnect();
  const taggingId = el.parentElement?.dataset?.refappTaggingId;
  if (taggingId) trackedSections.delete(taggingId);
}

export default {
  // Vue 2.x syntax
  inserted(el, binding) {
    setup(el, binding);
  },

  unbind(el) {
    cleanup(el);
  },

  // Vue 3.x syntax
  mounted(el, binding) {
    setup(el, binding);
  },

  beforeUnmount(el) {
    cleanup(el);
  },
};
